import { NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../../icon';
import { SpinnerComponent } from '../../spinner';

@Component({
  selector: 'sc-no-appointments-list',
  styleUrls: ['./no-appointments-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, IconComponent, SpinnerComponent, TranslateModule],
  template: `
    <div class="no-result-bloc" *ngIf="!loading">
      <div class="no-result-icon">
        <sc-icon
          aria-hidden="true"
          [name]="'calendar_hour'"
          specificName="no-appointments-list-header-icon"
        ></sc-icon>
      </div>
      <div class="sc-design-text-2">
        <p>{{ 'AppointmentEarliestList.noResultTitle' | translate }}</p>
      </div>
      <div class="sc-design-text-3">
        <p>{{ getDisplayedTextKey() | translate }}</p>
      </div>
    </div>
    <div class="no-result-bloc" *ngIf="loading">
      <sc-spinner></sc-spinner>
    </div>
  `,
})
export class NoAppointmentsListComponent {
  @Input() hasFitters: boolean;
  @Input() loading: boolean;

  getDisplayedTextKey() {
    return this.hasFitters
      ? 'AppointmentEarliestList.noFilterText'
      : 'AppointmentEarliestList.noResultText';
  }
}
